import { Injectable } from '@angular/core';

import { AuthService } from '../services/AuthService';

@Injectable({ providedIn: 'root' })
export class UnauthorizedGuard  {
    constructor(private authService: AuthService) {
    }

    canActivate() {
        return !this.authService.isLoggedIn || this.authService.isLoggedIn && this.authService.isTokenExpired;
    }
}
